export const CONSENT_STORAGE_KEYS = {
  shown: "consentIsShown",
  date: "consentDate",
  adStorage: "adConsent",
  adUserData: "adUserData",
  analyticsStorage: "analyticsConsent",
  adPersonalization: "adPersonalization",
} as const;

export const CONSENT_VALIDITY_MS = 365 * 24 * 60 * 60 * 1000;

export const OPEN_COOKIE_SETTINGS_EVENT = "brieflands:open-cookie-settings";

export type ConsentValue = "granted" | "denied";

export interface StoredConsent {
  adStorage: ConsentValue;
  adUserData: ConsentValue;
  analyticsStorage: ConsentValue;
  adPersonalization: ConsentValue;
}

const asConsentValue = (value: string | null): ConsentValue =>
  value === "granted" ? "granted" : "denied";

export const readStoredConsent = (): StoredConsent | null => {
  try {
    const date = localStorage.getItem(CONSENT_STORAGE_KEYS.date);
    if (localStorage.getItem(CONSENT_STORAGE_KEYS.shown) !== "true" || !date) {
      return null;
    }
    const age = Date.now() - Date.parse(date);
    if (!(age >= 0 && age < CONSENT_VALIDITY_MS)) {
      return null;
    }
    return {
      adStorage: asConsentValue(
        localStorage.getItem(CONSENT_STORAGE_KEYS.adStorage),
      ),
      adUserData: asConsentValue(
        localStorage.getItem(CONSENT_STORAGE_KEYS.adUserData),
      ),
      analyticsStorage: asConsentValue(
        localStorage.getItem(CONSENT_STORAGE_KEYS.analyticsStorage),
      ),
      adPersonalization: asConsentValue(
        localStorage.getItem(CONSENT_STORAGE_KEYS.adPersonalization),
      ),
    };
  } catch {
    return null;
  }
};

export const storeConsent = (consent: StoredConsent): void => {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEYS.shown, "true");
    localStorage.setItem(CONSENT_STORAGE_KEYS.date, new Date().toISOString());
    localStorage.setItem(CONSENT_STORAGE_KEYS.adStorage, consent.adStorage);
    localStorage.setItem(CONSENT_STORAGE_KEYS.adUserData, consent.adUserData);
    localStorage.setItem(
      CONSENT_STORAGE_KEYS.analyticsStorage,
      consent.analyticsStorage,
    );
    localStorage.setItem(
      CONSENT_STORAGE_KEYS.adPersonalization,
      consent.adPersonalization,
    );
  } catch {
    // localStorage unavailable: the gtag update still applies for this page.
  }
};

export const openCookieSettings = (): void => {
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
};
